import { IMeasureValue } from './calculation-value';

export class SummaryCalculationValue {
  measureValues: IMeasureValue = {};
  scenarioValues: IMeasureValue = {};
}
